import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const MrfApprovalsList = ({
  approvalList,
  getApprovalList,
  acceptApproval,
  rejectApproval,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    if (getApprovalList !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovalList();
        setIsLoading(false);
      })();
    }
  }, [getApprovalList]);

  const Headers = [
    'Site No',
    'Client Name',
    'Requested By',
    'Requested On',
    'Approve',
    'Action',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'client_name',
      'requested_by',
      'requested_date',
    ];

    if (approvalList !== {} && approvalList.mrf_approval_list) {
      console.log(approvalList);
      const data = approvalList.mrf_approval_list.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          element['status'] === 2
            ? {
                status: 'Accepted',
                Actions: {
                  name: 'View Details',
                  link: `${baseUrl}/view-material-requisition/${element.id}/stage/1`,
                },
              }
            : element['status'] === 4
            ? {
                status: 'Rejected',
                Actions: {
                  name: 'View Details',
                  link: `${baseUrl}/view-material-requisition/${element.id}/stage/1`,
                },
              }
            : {
                'Approve/Reject': '',
                Actions: {
                  name: 'View Details',
                  link: `${baseUrl}/view-material-requisition/${element.id}/stage/1`,
                },
              }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      await acceptApproval(data.actionObj.id).then(async (response) => {
        if (response) {
          await getApprovalList();
          setIsModal(true);
        }
      });
    } else {
      setIsModal(true);
    }
  };

  const handleModalHide = () => setIsModal(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Button onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getApprovalList(val.selected + 1);
    setIsLoading(false);
  };

  const handleRejection = async (info) => {
    setIsModal(false);
    if (info.action === 'reject') {
      setIsLoading(true);
      await rejectApproval(info.actionObj.id).then(async (response) => {
        if (response) {
          await getApprovalList();
          setIsLoading(false);
          setIsSuccessModel(true);
        }
      });
    }
  };

  return (
    <Layout title={localization.mrfApprovals} isLoading={isLoading}>
      <TableSection
        data={listData}
        headers={Headers}
        detailList={approvalList && approvalList.resultSets}
        onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
        srNo={approvalList?.from}
      />
      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={() => setIsModal(false)}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <div className="modal-body">
            <div className="text-center">
              <h5>{localization.mrfRejection}</h5>
              <Button
                className="btn btn-primary mb-4"
                onClick={() => handleRejection(actionData)}
              >
                {localization.continue} <img src={Images?.ArrowRight} alt="" />
              </Button>
              <Button
                onClick={() => setIsModal(false)}
                className="btn btn-transparent"
              >
                {localization.returnToApproval}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </div>
        ) : (
          successIconBox(localization.approveSuccess, handleModalHide)
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={() => setIsSuccessModel(false)}
      >
        {successIconBox(localization.mrfApproveReject, () =>
          setIsSuccessModel(false)
        )}
      </ModalPop>
    </Layout>
  );
};

MrfApprovalsList.propTypes = {
  approvalList: PropTypes.any,
  getApprovalList: PropTypes.any,
  acceptApproval: PropTypes.any,
  rejectApproval: PropTypes.func,
};

export default MrfApprovalsList;
